// extracted by mini-css-extract-plugin
export default {"container":"jO-z","topReviewHeading":"kO-z","criticalReview":"lO-z","favorableReview":"mO-z","vsSeparator":"nO-z"};